import { NftActivities } from "@/app/(components)/Application/Nft/NftActivityDescription/types";
import { DEFAULT_PAGE_SIZE } from "@/shared/constants";
import { withClientRequest } from "../requestBuilder/withClientRequest";
import requests from "./requests";

export const getEnrichedActivities = async (
  initiatorIds: string[] = [],
  activityTypes: NftActivities[] = [],
  nftContract: string | null = null,

  skip: number = 0,
  take: number = DEFAULT_PAGE_SIZE,
) => {
  return await withClientRequest(requests.getAllActivities)(
    initiatorIds,
    activityTypes,
    nftContract,
    skip,
    take,
  );
};

const clientRequests = {
  getPurchaseHistory: withClientRequest(requests.getPurchaseHistoryActivities),
  getAllActivities: withClientRequest(requests.getAllActivities),
  getNftItemActivities: withClientRequest(requests.getNftItemActivities),
  getReserveActivities: withClientRequest(requests.getReserveActivities),
};

export default clientRequests;
